// extracted by mini-css-extract-plugin
export default {"main":"project_main__C+RQk","body":"project_body__f9eZF"};